import type { ReactNode } from 'react'
// Subpath, NOT the '@edge/charts' barrel — mounts eagerly in main.tsx; the
// barrel would pull the klinecharts runtime into the entry bundle (see the
// '@edge/charts/interaction' precedent).
import { ChartColorPickerContext, type ChartColorPickerComponent } from '@edge/charts/color-picker'
import { ColorSwatchPicker } from '@/components/ui/color-swatch-picker'

// Opacity is opt-in per call site. Indicator drawer renders its own opacity row
// and omits `showOpacity`; settings modal passes `showOpacity` for fills.
const renderColorPicker: ChartColorPickerComponent = ({ value, onChange, title, showOpacity }) => (
  // h-5 w-5: one 20px swatch size across every chart settings surface — the
  // 24px default read oversized next to the drawers' 12px control rows.
  <ColorSwatchPicker
    value={value}
    onChange={onChange}
    title={title}
    hideOpacity={!showOpacity}
    className="h-5 w-5 border-transparent ring-1 ring-inset ring-[hsl(var(--chart-text)/0.2)]"
  />
)

export function ChartColorPickerProvider({ children }: { children: ReactNode }) {
  return (
    <ChartColorPickerContext.Provider value={renderColorPicker}>
      {children}
    </ChartColorPickerContext.Provider>
  )
}
